import React, { useEffect, useState } from 'react';
import {main_url} from  './basefile';

import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from '@mui/material';

function QuestionAnswerList({execid,schdid}) {
  const [questions, setQuestions] = useState([]);
const [answers, setAnswers] = useState([]); // <-- add this

  useEffect(() => {
    fetchAllQuestions();
  }, []);

   const getAnswerForQuestion = (questiobj) => {
  //  const qAnswer = answers.find((a) => a.question == questionId);

     //  if (!answers || !Array.isArray(answers)) return '-';
     const qAnswer  = questiobj;
    

      // if (!qAnswer) return '—';

    switch (qAnswer.question_type) {

      case 'text':
        return qAnswer.text_answer || '—';
      case 'boolean':
        return qAnswer.boolean_answer === true
          ? 'Yes'
          : qAnswer.boolean_answer === false
          ? 'No'
          : '—';
      case 'integer':
        return qAnswer.integer_answer ?? '—';
      case 'single':
      case 'multiple':
     //alert( qAnswer.selected_options);
     return Array.isArray(qAnswer.selected_options) && qAnswer.selected_options.length > 0
                ? qAnswer.selected_options
                    .map((id) => {
                      const opt = qAnswer.options.find((o) => o.id === id);
                      return opt?.text || opt?.label || '—';
                    })
                    .join(', ')

                : '—';

      case 'image':
        return qAnswer.images?.length > 0 ? `${qAnswer.images.length} image(s)` : '—';
      case 'slider':  
        return qAnswer.integer_answer;
      default:
        return '—';
    }
  };

  const fetchAllQuestions = async () => {
    const token = localStorage.getItem('authToken');
   
    const execution_pk =execid;
    const schedule_pk = schdid;
    try {
      // change this API
      const res = await fetch(`${main_url}/api/v1/executions/${execution_pk}/schedules/${schedule_pk}/answers/`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(errorText);
      }

      const data = await res.json();
       //alert(JSON.stringify(data));

      const formatted = data.results.map((q, i) => ({
        ...q,
        order: i,
        options: q.options || [],
      }));

      setQuestions(formatted);
    } catch (error) {
      console.error('❌ Failed to fetch questions:', error.message);
      alert('Failed to fetch questions.');
    }
  };

  return (
    <Box p={4} maxWidth={1000} mx="auto" >
      <Typography variant="h5" gutterBottom sx={{fontWeight:'bold'}}> 
        Q & Answer for this Schedule 
      </Typography>

      {questions.length === 0 ? (
        <Typography>No questions available.</Typography>
      ) : (
        <Paper elevation={2} sx={ {bgcolor:"#f5f5f5", borderRadius:3 }} >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>ID</strong></TableCell>
                <TableCell><strong>Question</strong></TableCell>
                <TableCell><strong>Type</strong></TableCell>
                <TableCell><strong>Options</strong></TableCell>
                <TableCell><strong>Answer</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {questions.map((q, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{q.question_text}</TableCell>
                  <TableCell>{q.question_type}</TableCell>
                  <TableCell>
                    {q.options && q.options.length > 0 ? (
                      <ul style={{ paddingLeft: 16, margin: 0 }}>
                        {q.options.map((opt, i) => (
                          <li key={i}>{opt.label || opt.text}</li>
                        ))}
                      </ul>
                    ) : (
                      '-'
                    )}
                  </TableCell>
                   <TableCell>{getAnswerForQuestion(q)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )}
    </Box>
  );
}

export default QuestionAnswerList;
